<template>
    <div class="inline-block" v-auto-animate>
        <button
            type="button"
            @click="selectNone()"
            v-if="maxCount && someSelected"
            :title="$t('messages.deselect_all')"
        >
            <IconBorderNone class="h-6 w-6 text-gray-400" />
        </button>
        <button type="button" @click="selectAll()" v-if="notAllSelected" :title="$t('messages.select_all')">
            <IconBorderAll class="h-6 w-6 text-gray-400" />
        </button>
    </div>
</template>
<script setup>
import { IconBorderAll, IconBorderNone } from '@tabler/icons-vue';
import { computed } from 'vue';

const props = defineProps({
    maxCount: {
        type: Number,
        required: true,
    },
    selectedCount: {
        type: Number,
        required: true,
    },
});

const emit = defineEmits(['selectAll', 'selectNone']);

function selectAll() {
    emit('selectAll');
}

function selectNone() {
    emit('selectNone');
}

const notAllSelected = computed(() => props.selectedCount !== props.maxCount);

const someSelected = computed(() => props.selectedCount !== 0);
</script>
